export default __webpack_public_path__ + "static/media/theme10-packages-bg.1e9819be.png";